import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { SearchResult } from '@nstep-common/core';
import { valueHasChanged } from '@nstep-common/utils';

@Component({
	selector: 'app-lookup',
	templateUrl: './lookup.component.html',
	standalone: false
})
export class LookupComponent implements AfterViewInit, OnChanges, OnDestroy {
	jQueryElement: any;

	@Input() result: SearchResult<any> | null = null;

	@Output() resultChange = new EventEmitter<SearchResult<any> | null>();

	@Input() onSearch!: (term: string, callback: (results: SearchResult<any>[]) => void) => void;

	displayItems = 50;
	totalItems = '';

	constructor(private elementRef: ElementRef) { }

	ngAfterViewInit(): void {
		if (this.jQueryElement) {
			return;
		}

		this.jQueryElement = $(this.elementRef.nativeElement)
			.find('.ui.search')
			.search({
				minCharacters: 3,
				searchOnFocus: false,
				searchDelay: 300,
				cache: false,
				maxResults: this.displayItems,
				onSelect: (result: any) => {
					this.result = result;
					this.resultChange.emit(result);

					return true;
				},
				onResults: (response: any) => {
					this.totalItems = response.count > this.displayItems
						? 'Showing ' + this.displayItems + ' out of ' + response.count + ' item(s).'
						: 'Found ' + response.count + ' item(s).';
				},
				onResultsClose: () => {
					this.totalItems = '';
				},
				apiSettings: {
					responseAsync: (_: any, callback: any) => {
						const key = this.jQueryElement.search('get value');

						if (!key) {
							callback({
								success: false,
								results: [],
								count: 0
							});
							return;
						}

						this.onSearch(key, (results) => {
							callback({
								success: true,
								results,
								count: results.length
							});
						});
					}
				}
			});

		this.updateResult();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!this.jQueryElement) {
			return;
		}

		if (valueHasChanged(changes['result'])) {
			this.updateResult();
		}
	}

	onInputKeyup(event: KeyboardEvent): void {
		const input = (event.target as HTMLInputElement).value;

		if (input === '' && this.result !== null) {
			this.result = null;
			this.resultChange.emit(null);

			this.jQueryElement.search('cancel query');
			this.jQueryElement.search('set value', null);
		}
	}

	private updateResult(): void {
		if (!this.result || !this.jQueryElement) {
			this.jQueryElement.search('set value', null);
			return;
		};

		const result = {
			title: this.result.title || '',
			description: this.result.description || '',
			obj: this.result
		};

		this.jQueryElement.search('set value', result.title);
	}

	ngOnDestroy(): void {
		this.jQueryElement?.search('destroy');
	}
}